/*
 * @Description:
 * @Autor: jyf
 * @Date: 2022-03-31 14:34:49
 * @LastEditors: jyf
 * @LastEditTime: 2022-04-11 10:38:38
 */
import { Post, Get, Patch, Put, Delete, Download, ax, Import } from './http';
import { type } from './interface';
import qs from 'qs';
export namespace Dock {
    /**
     *  月台列表
     */
    export var GetDockList = (query: any): Promise<any> => {
        return Get(`/msls/Dock/getDockList?${qs.stringify(query)}`, '');
    };
    /**
     * 获取月台详情
     */
    export var GetDockDetail = (id: any): Promise<any> => {
        return Get(`/msls/Dock/getDockDetail/${id}`, {});
    };
    /**
     *  新增月台
     */
    export var AddDock = (body: any): Promise<any> => {
        return Post(`/msls/Dock/addDock`, body);
    };
    /**
     * 编辑月台
     */
    export var EditDock = (id: any, body: any): Promise<any> => {
        return Put(`/msls/Dock/saveDock/${id}`, body);
    };

}
